import { render, staticRenderFns } from "./NewKycFlow.vue?vue&type=template&id=5fa6e6b1&scoped=true"
import script from "./NewKycFlow.vue?vue&type=script&lang=js"
export * from "./NewKycFlow.vue?vue&type=script&lang=js"
import style0 from "./NewKycFlow.vue?vue&type=style&index=0&id=5fa6e6b1&prod&lang=scss&scoped=true"
import style1 from "./NewKycFlow.vue?vue&type=style&index=1&id=5fa6e6b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa6e6b1",
  null
  
)

export default component.exports